// client/src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Stack, TextField } from '@mui/material';
import AuthLayout from '../components/AuthLayout';
import { API_BASE_URL } from '../utils/media';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) throw new Error('Something went wrong. Please try again.');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Forgot your password?"
      title="Let's get you back in"
      footer={<Link to="/login" style={{ color: 'inherit', fontWeight: 700 }}>Back to sign in</Link>}
    >
      {sent ? (
        <Alert severity="success">
          If <strong>{email}</strong> has an account, a reset link is on its way. It expires in 60 minutes, so check your spam folder if you can't see it.
        </Alert>
      ) : (
        <Stack component="form" onSubmit={handleSubmit} spacing={2.25}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth autoComplete="email" />
          <Button type="submit" variant="contained" size="large" disabled={loading}>
            {loading ? 'Sending…' : 'Email me a reset link'}
          </Button>
        </Stack>
      )}
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
